/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as _ from 'lodash';
export const getPercentagesFromWidths = function (columnWidths) {
  let extendedColumnWidths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const totalWidth = _.sum(columnWidths);
  const percents = _.map(columnWidths, width => {
    return `${width / totalWidth * 100}%`;
  });
  // uses total from columnWidths to define scaling of width per unit; starts on the next
  const extendedPercents = _.map(extendedColumnWidths, width => {
    return `${width / totalWidth * 100}%`;
  });
  return _.concat(percents, extendedPercents);
};